import { render, staticRenderFns } from "./studio-logo.vue?vue&type=template&id=2c1586b0&scoped=true&"
import script from "./studio-logo.vue?vue&type=script&lang=js&"
export * from "./studio-logo.vue?vue&type=script&lang=js&"
import style0 from "./studio-logo.vue?vue&type=style&index=0&id=2c1586b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1586b0",
  null
  
)

export default component.exports